// extracted by mini-css-extract-plugin
export default {"stand":"Stand_stand__rCvQz","inputs":"Stand_inputs__ymC7y","buttons":"Stand_buttons__Gmxoo","checkboxes":"Stand_checkboxes__wa9mH"};